useLoadableQuery